import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mt-2",
  align: "end"
}

import { useI18n } from "vue-i18n"
import {
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
  watch,
} from "vue"
import { hospitalActions } from "@/stores/hospital-actions"
import { Department, Departments, RequestResponse } from "@/types"
import { useToast } from "vue-toast-notification"


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteDoctor',
  emits: ["close", "invited"],
  setup(__props, { emit: __emit }) {

const emit = __emit
const { t } = useI18n()
const hospitalAction = hospitalActions()
const email = ref<string>("")
const $toast = useToast()
const smallWindow = ref(window.innerWidth < 1000)
const requestResponse = ref()
const departments = ref<Department[]>([])
const chosenDepartment = ref<string | null>(null)
const locale = ref(localStorage.getItem("locale") || "de")

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

const notEmptyRule = [(v: string) => !!v || t("field-required")]

onMounted(async () => {
  window.addEventListener("resize", updateWindowSize)
  await getDepartments()
  window.addEventListener("locale-changed", updateLocale)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
  window.removeEventListener("locale-changed", updateLocale)
})

const updateLocale = () => {
  locale.value = localStorage.getItem("locale") ?? "de"
}

const getDepartmentName = computed(() => (department: Department): string => {
  return locale.value == "de" ? department.de : department.en
})
const getDepartmentValue = (department: Department): string => {
  return department.value
}

const emailRules = [
  (v: string) => !!v || t("email-required"),
  (v: string) => /.+@.+\..+/.test(v) || t("email-authentic"),
]

const isInfoCompleted = computed(() => {
  const isEmailInvalid = emailRules.some((rule) => {
    const result = rule(email.value)
    return typeof result === "string"
  })

  return !isEmailInvalid && chosenDepartment.value
})

const getDepartments = async () => {
  const response = await hospitalAction.getDepartments()
  if (response.success) {
    departments.value = response.result as Department[]
  }
}

const invite = async (): Promise<void> => {
  const data = {
    doctorEmail: email.value,
    department: chosenDepartment.value,
  }
  const response = await hospitalAction.inviteDoctor(data)
  requestResponse.value = response
  if (response.success) {
    $toast.success(t("notifications.invite-send-successful"), {
      position: "bottom-left",
    })
  } else {
    $toast.error(response.message ?? "", {
      position: "bottom-left",
    })
  }
  emit("invited")
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, { "max-width": "450px" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        class: "mx-auto pa-2",
        style: {"font-family":"Verdana, Geneva, Tahoma, sans-serif"},
        elevation: "8",
        width: smallWindow.value ? '350px' : '500px',
        rounded: "lg"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center mb-5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("hospital.add-doctor")) + " ", 1),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
            density: "compact",
            placeholder: _ctx.$t('email'),
            rules: emailRules,
            "prepend-inner-icon": "mdi-email-outline",
            variant: "outlined",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (isInfoCompleted.value ? invite() : undefined), ["enter"]))
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_v_autocomplete, {
            modelValue: chosenDepartment.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((chosenDepartment).value = $event)),
            density: "compact",
            placeholder: _ctx.$t('hospital.department'),
            items: departments.value,
            "item-title": getDepartmentName.value,
            "item-value": getDepartmentValue,
            "prepend-inner-icon": "mdi-hospital-building",
            variant: "outlined",
            rules: notEmptyRule,
            "menu-props": { width: '300px' },
            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (isInfoCompleted.value ? invite() : undefined), ["enter"]))
          }, null, 8, ["modelValue", "placeholder", "items", "item-title"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_btn, {
              color: "#3fb984",
              onClick: invite,
              disabled: !isInfoCompleted.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("hospital.send-invite")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["width"])
    ]),
    _: 1
  }))
}
}

})